// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-agreement-view-version .AgreementViewVersionPage {
  height: calc(100% - 60px);
  overflow: auto;
}
.fi-agreement-view-version .AgreementViewVersionPage .versions-wrapper {
  margin: 10px;
}
.fi-agreement-view-version .AgreementViewVersionPage .versions-wrapper fi-agreement-version-view {
  display: inline-block;
  margin: 10px;
  width: calc(50% - 40px);
  vertical-align: top;
}
.fi-agreement-view-version .AgreementViewVersionPage .versions-wrapper fi-agreement-version-view img {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/agreement/agreement-view-version/agreement-view-version.component.scss"],"names":[],"mappings":"AACI;EACI,yBAAA;EACA,cAAA;AAAR;AACQ;EACI,YAAA;AACZ;AACY;EACI,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAChB;AACgB;EACI,eAAA;AACpB","sourcesContent":[".fi-agreement-view-version {\r\n    .AgreementViewVersionPage {\r\n        height: calc(100% - 60px);\r\n        overflow: auto;\r\n        .versions-wrapper {\r\n            margin: 10px;\r\n\r\n            fi-agreement-version-view {\r\n                display: inline-block;\r\n                margin: 10px;\r\n                width: calc(50% - 40px);\r\n                vertical-align: top;\r\n\r\n                img {\r\n                    max-width: 100%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
